<template>
  <main>
    <menus/>
    <div class="cont">
      <nav>
        <span>优惠券状态：</span>
        <a :class="{ on: i === navIndex }" v-for="(v, i) in nav" :key="v.label" @click="changeNavIndex(i)">{{v.label}}</a>
      </nav>
      <el-table
        class="table"
        :data="coupon">
        <el-table-column prop="title" label="优惠券名称"></el-table-column>
        <!-- <el-table-column  label="优惠券类型"></el-table-column> -->
        <!-- <el-table-column label="使用范围"></el-table-column> -->
        <el-table-column label="优惠额度">
          <template slot-scope="s">
            <span class="price">{{s.row.amount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="use_edate" label="有效期至"></el-table-column>
        <el-table-column label="优惠券状态">
          <template>
            <span class="state" :class="'s'+navIndex">{{ nav[navIndex].label }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="s">
            <router-link :to="{name: 'coupon_info', query: { id: s.row.id }}">详情</router-link>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        background 
        layout="prev, pager, next" :total="1000">
      </el-pagination> -->
    </div>
  </main>
</template>

<script>
import menus from '@components/menu';
import moment from 'moment';
import { mapState } from 'vuex';
export default {
  components: {
    menus
  },
  data () {
    return {
      navIndex: 0,
      nav: [
        { label: '待使用', value: 'available' },
        { label: '已使用', value: 'used' },
        { label: '已失效', value: 'expired' }
      ],
      coupon: []
    }
  },
  async created () {
    this.getList();
  },
  filters: {
  },
  computed: {
    ...mapState([
      'userInfo'
    ])
  },
  methods: {
    async getList () {
      const { navIndex, nav } = this;
      const res = await this.$axios.get(`mycoupon/listByStatus/${nav[navIndex].value}`);
      this.coupon = res;
    },
    changeNavIndex (index) {
      if ( index === this.navIndex ) { return; }
      this.navIndex = index;
      this.getList();
    }
  }
}
</script>

<style scoped src="./list.css"></style>